import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IDsDropdownOption} from "../../../../../../../shared/components/ds-dropdown/ds-dropdown-option";
import {FormBuilder} from "@angular/forms";
import {ProductAddHelperService} from "../../product-add-helper.service";

@Component({
    selector: 'db-product-batch-edit',
    templateUrl: './product-batch-edit.component.html',
    styleUrl: './product-batch-edit.component.scss',
    standalone: false
})
export class ProductBatchEditComponent {
  @Input() title: string;
  @Input() symbol: string;
  @Input() type: string = 'price';
  @Input() disablePropagation: boolean = true;
  @Input() statusOptions: IDsDropdownOption[] = [];
  formGroup = this._fb.group({
    price: ['', this._productAddHelper.priceValidation],
    sale_price: ['', this._productAddHelper.priceValidation],
    inventory: '',
    weight: '',
    height: '',
    width: '',
    length: '',
    status: '',
  });
  editSale = false;
  @Output() saveValue: EventEmitter<{
    price: string,
    sale_price: string,
    inventory: string,
    weight: string,
    height: string,
    width: string,
    length: string,
  }> = new EventEmitter<{
    price: string,
    sale_price: string,
    inventory: string,
    weight: string,
    height: string,
    width: string,
    length: string,
  }>;
  measurements = this._productAddHelper.measurements.value;

  constructor(private _fb: FormBuilder,
              private _productAddHelper: ProductAddHelperService) {
  }

  discard() {
    this.close();
  }

  add() {
    this.saveValue.emit(this.formGroup.getRawValue());
    this.close();
  }

  returnNum(str) {
    const num = str.replace(/[^0-9]/g, '');
    return parseInt(num, 10);
  }

  close() {
    document.getElementById('variants-dialog').click();
  }

}
